import React from "react"
import { usePaletteTheme } from "../../../context/paletteTheme"
import { MenuItem, Select, ListItemIcon, ListItemText, FormControl } from '@mui/material'
import { Done } from '@mui/icons-material'
import styles from './OnboardingUser.module.scss'

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 300,
      width: 310
    }
  },
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center"
  },
  variant: "menu"
}

function Selector({options, renderChosenOptionSign = <Done/>, selected, handleChange, placeholder, label, style={ margin: 8, width: 310}}) {
  const { colors } = usePaletteTheme()
  const renderValue = (selected) => selected.length ? selected.join(", ") : selected

  const onChange = (_, value) =>   {
    const updated = value.props.value
    handleChange(!selected.includes(updated) 
      ? [...selected, updated] 
      : selected.filter(item => item !== updated)
    )
  }

  return (
    <div>
      {label && <p className={styles['label']}>{label}</p>}
        <FormControl style={style} variant="outlined">                                   
          <Select
            id='select-onboaring-user'
            multiple
            value={selected?.length ? selected : [placeholder]}
            onChange={onChange}
            renderValue={renderValue}
            MenuProps={MenuProps}
            style={{color: !selected?.length ? colors.textSecondary : ''}}
          >
            {options?.map((option) => renderItem(option, selected, renderChosenOptionSign))}
          </Select>
        </FormControl>
    </div>
  )  
}

const renderItem = (item, selected, chosenSign) => (
  <MenuItem key={`${item.name}_${item.value}`} value={item.name}>
    <ListItemText primary={item.name}/>
    {(selected?.indexOf(item.name) > -1 || selected?.indexOf(item.value) > -1) &&
    <ListItemIcon classes={{root: styles['selected-icon']}}>
      {chosenSign}
    </ListItemIcon>}
  </MenuItem>
)

export default Selector
